import React, {Fragment} from 'react';
import { connect as reduxConnect } from "react-redux";
import { connect } from 'formik';
import { compose} from "redux";
import {Grid} from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
  SideLabelTextAreaInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelMoneyWithRefInput,
  SideLabelMoneyInput,
  SideLabelAutoCompleteInput,
  SideLabelAutoCompleteWithRefInput,
  SideLabelDecimalInputWithRefInput,
  SideLabelMoneyAndAutoCompleteWithRefInput,
  SideLabelMoneyWithDecimalsAndAutoCompleteWithRefInput,
  SideLabelRadioWithRefInput,
  SideLabelCheckboxSelectListInput,
  SideLabelDateInputWithRefInput
 } from '../FormSectionComponents';  
import { SideLabelCalculatedField } from 'components/HedgeDetailPage/FormSectionComponents';
import numberFormatter from 'utils/numberFormatter';
  
const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`

const YES =  {id: 1, value: true, name: ""};
const YES_NO = [YES];

class EscrowAccountsChildSection extends React.Component {  

  
  getPropertySizeById = (id) => {
    let propertySizes = this.props.propertySizes;
    if(propertySizes && propertySizes.filter(x=>x.id==id) && propertySizes.filter(x=>x.id==id).length > 0){
      return propertySizes.filter(x=>x.id==id)[0].name.toLowerCase();
    }
    return null;
  }

  render(){    
    const {formik, isEditing, propertySizes} = this.props;
    
    return (
      <Fragment>
        <div id="covenants_section_escrow_accounts">
        <ChildSectionTitle>Escrow Accounts</ChildSectionTitle>
        <StyledGrid container alignItems="center" direction="column">

          <SideLabelCheckboxSelectListInput label="Tax Reserve" hasBorder fieldName="covenants.taxReserve" refFieldName="covenants.taxReserveRef" isDisabled={!isEditing} setFieldValue={formik.setFieldValue} options={YES_NO} />
          <SideLabelCheckboxSelectListInput label="Insurance Reserve" hasBorder fieldName="covenants.insuranceReserve" refFieldName="covenants.insuranceReserveRef" isDisabled={!isEditing} setFieldValue={formik.setFieldValue} options={YES_NO} />

          <SideLabelMoneyWithRefInput label="Interest Reserve" hasBorder placeholder="Interest Reserve" fieldName="covenants.interestReserve" isDisabled={!isEditing}/>
          <SideLabelTextAreaWithRefInput label="Interest Reserve Misc." hasBorder placeholder="Interest Reserve Misc." fieldName="covenants.interestReserveMisc" isDisabled={!isEditing}/>
          <SideLabelMoneyWithDecimalsAndAutoCompleteWithRefInput
              label="Replacement Reserve"
              midLabel= {this.getPropertySizeById( _.get(formik.values, "covenants.replacementPerId")) == "at close" ? "" : "per"}
              moneyFieldName="covenants.replacementReserve"              
              refFieldName="covenants.replacementReserveRef"
              ddlFieldName="covenants.replacementPerId"
              options={propertySizes}
              selectName="name"
              selectValue="value"              
              hasBorder          
              isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput 
              hasBorder 
              label="Replacement Reserve Acct." 
              placeholder="Replacement Reserve Account" 
              fieldName="covenants.replacementReserveAccount" 
              isDisabled={!isEditing}/>
            <SideLabelMoneyWithDecimalsAndAutoCompleteWithRefInput
              label="Repair Reserve"
              midLabel= {this.getPropertySizeById( _.get(formik.values, "covenants.repairPerId")) == "at close" ? "" : "per"}
              moneyFieldName="covenants.repairReserve"              
              refFieldName="covenants.repairReserveRef"
              ddlFieldName="covenants.repairPerId"
              options={propertySizes}
              selectName="name"
              selectValue="value"              
              hasBorder          
              isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput 
              hasBorder 
              label="Repair Reserve Acct." 
              placeholder="Repair Reserve Account" 
              fieldName="covenants.repairReserveAccount" 
              isDisabled={!isEditing}/>
          <SideLabelMoneyWithRefInput label="Good News Money" hasBorder placeholder="Good News Money" fieldName="covenants.tilcReserves" isDisabled={!isEditing}/>
          <SideLabelDateInputWithRefInput label="Good News Deadline" hasBorder placeholder="MM/DD/YYYY" fieldName="covenants.goodNewsMoneyDeadline" isDisabled={!isEditing}/>
          <SideLabelTextAreaWithRefInput label="Good News Money Misc." hasBorder placeholder="Good News Money Misc." fieldName="covenants.tilcReservesMisc" isDisabled={!isEditing}/>
          {!this.props.isQuote && <>
          <SideLabelMoneyWithRefInput label="Good News Money Drawn" hasBorder placeholder="Good News Money Drawn" fieldName="covenants.goodNewsMoneyDrawn" isDisabled={!isEditing}/>   
          <SideLabelCalculatedField
                  hasBorder
                  label="Good News Money Remaining"
                  calculationFunc = { (fieldValues) => {
                                          let startingAmount = parseFloat(_.get(fieldValues, "covenants.tilcReserves"));
                                          let amountDrawn = parseFloat(_.get(fieldValues, "covenants.goodNewsMoneyDrawn"));
                                          if(startingAmount === null || amountDrawn === null || amountDrawn > startingAmount) {
                                            return "--"
                                          }
                                          return numberFormatter.formatMoney(startingAmount-amountDrawn)
                                        }
                                      }
                  placeholder="Good News Money Remaining"
                  isDisabled={!isEditing}
                  isIndented = {true}
                />
            </>}
                
         
          <SideLabelMoneyWithRefInput label="Cap Ex Reserves" hasBorder placeholder="Cap Ex Reserves" fieldName="covenants.capExReserves" isDisabled={!isEditing}/>
          <SideLabelTextAreaWithRefInput label="Cap Ex Reserves Misc." hasBorder placeholder="Cap Ex Reserves Misc." fieldName="covenants.capExReservesMisc" isDisabled={!isEditing}/>          
         {!this.props.isQuote && <>
          <SideLabelMoneyWithRefInput label="Cap Ex Reserves Drawn" hasBorder placeholder="Cap Ex Reserves Drawn" fieldName="covenants.capExReservesDrawn" isDisabled={!isEditing}/>
          <SideLabelCalculatedField
                  formik = {this.props.formik}
                  hasBorder
                  label="Cap Ex Reserves Remaining"
                  calculationFunc = { (fieldValues) => {
                                          let startingAmount = parseFloat(_.get(fieldValues, "covenants.capExReserves"));
                                          let amountDrawn = parseFloat(_.get(fieldValues, "covenants.capExReservesDrawn"));

                                          if(startingAmount === null || amountDrawn === null || amountDrawn > startingAmount) {
                                            return "--"
                                          }
                                          return numberFormatter.formatMoney(startingAmount-amountDrawn)
                                        }
                                      }
                  placeholder="Cap Ex Reserves Remaining"
                  isDisabled={!isEditing}
                  isIndented = {true}
                />
            </>}
          <SideLabelTextAreaWithRefInput label="Operating Account" hasBorder placeholder="Operating Account" fieldName="covenants.operatingAccount" isDisabled={!isEditing}/>
          <SideLabelMoneyWithRefInput label="Min Cash Deposit" hasBorder placeholder="Min Cash Deposit" fieldName="covenants.minCashDeposit" isDisabled={!isEditing}/>
          
          <SideLabelMoneyWithRefInput      
              hasBorder         
              label="Debt Service Reserve" 
              placeholder="Debt Service Reserve" 
              fieldName="covenants.debtServiceReserve" 
              isDisabled={!isEditing}/>

          <SideLabelTextAreaWithRefInput     
          hasBorder          
              label="Debt Service Reserve Misc" 
              placeholder="Debt Service Reserve Misc" 
              fieldName="covenants.debtServiceReserveMisc" 
              isDisabled={!isEditing}/>

          
          <SideLabelMoneyWithRefInput  
          hasBorder             
              label="Shortfall Reserve" 
              placeholder="Shortfall Reserve" 
              fieldName="covenants.shortfallReserve" 
              isDisabled={!isEditing}/>

          <SideLabelTextAreaWithRefInput
          hasBorder               
              label="Shortfall Reserve Misc" 
              placeholder="Shortfall Reserve Misc" 
              fieldName="covenants.shortfallReserveMisc" 
              isDisabled={!isEditing}/>


            <SideLabelMoneyWithRefInput     
            hasBorder          
              label="Interest Rate Cap Reserve" 
              placeholder="Interest Rate Cap Reserve" 
              fieldName="covenants.interestRateCapReserve" 
              isDisabled={!isEditing}/>

          <SideLabelTextAreaWithRefInput     
          hasBorder          
              label="Interest Rate Cap Reserve Misc" 
              placeholder="Interest Rate Cap Reserve Misc" 
              fieldName="covenants.interestRateCapReserveMisc" 
              isDisabled={!isEditing}/>


          
          <SideLabelTextAreaWithRefInput 
          hasBorder              
              label="Misc. Reserves" 
              placeholder="Misc. Reserves" 
              fieldName="covenants.escrowAccountsMisc" 
              isDisabled={!isEditing}/>
        </StyledGrid>
        </div>
      </Fragment>
  )};
}

const mapStateToProps = () => ({});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
    {
    }
  )
)(EscrowAccountsChildSection);

